import { CHECKOUT_INFO } from '../constants/local-storage-constants';
import { FAVORITE_DELIVERY_TYPE } from 'common/constants';
import { CheckoutInfo } from 'types/checkout-info';
import { DeletableFavoriteAddressType } from 'types/favorite-address';

export const getCheckoutInfo = (): CheckoutInfo | null => {
  try {
    const raw = localStorage.getItem(CHECKOUT_INFO);

    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const setLocalStorageItem = (key: string, value: string, skipEvent = false) => {
  localStorage.setItem(key, value);

  if (skipEvent) return;

  const event = new CustomEvent('local-storage-update', { detail: { key, value } });
  window.dispatchEvent(event);
};

export const setCheckoutInfo = (checkoutInfo: CheckoutInfo | null, skipEvent = false): void => {
  if (!checkoutInfo) return;

  const { deliveryType, ...rest } = checkoutInfo;
  const next = deliveryType === FAVORITE_DELIVERY_TYPE.REGION ? rest : checkoutInfo;

  setLocalStorageItem(CHECKOUT_INFO, JSON.stringify(next), skipEvent);
};

export const applyCheckoutInfoDeletions = (
  checkoutInfo: CheckoutInfo | null,
  deletedTypes: DeletableFavoriteAddressType[],
): CheckoutInfo | null => {
  if (!checkoutInfo || deletedTypes.length === 0) return checkoutInfo;

  const deleted = new Set(deletedTypes);
  const next = { ...checkoutInfo };

  if (deleted.has(FAVORITE_DELIVERY_TYPE.HOME_DELIVERY)) delete next.address;

  if (deleted.has(FAVORITE_DELIVERY_TYPE.PICKUP)) delete next.storeId;

  if (deleted.has(FAVORITE_DELIVERY_TYPE.PICKUP_POINT)) delete next.pointId;

  if (deleted.has(next.deliveryType as DeletableFavoriteAddressType)) {
    next.deliveryType = FAVORITE_DELIVERY_TYPE.REGION;
  }

  return next;
};
